export default {
  DEFAULT: {
    TITLE: `Default configuration`,
    SUMMARY: `The configuration will be automatically selected based on these when required.`
  },
  DEFAULTFILTERMAINSCHEDULE: {
    LABEL: `Shift (filter)`,
    DESCRIPTION: `This filter will be used to determine the eligibility of users for the shifts (creation and modification).`
  },
  DEFAULTFILTEREMPLOYEELISTWARNINGS: {
    LABEL: `User list`,
    DESCRIPTION: `This filter will be used to show warning in the user list (expired contract, missing contract, etc).`
  },
  DEFAULTCONFIGCONTACTLISTS: {
    LABEL: `Contact list`,
    DESCRIPTION: `Default configuration to use for contact lists.`
  },
  DEFAULTFILTERQUICKADD: {
    LABEL: `Quick add`,
    DESCRIPTION: `Default filter to use for quick add in schedule template.`
  },
  DEFAULTSORTMAINSCHEDULE: {
    LABEL: `Shift (sort)`,
    DESCRIPTION: `This sort will be used to sort the users when assigning them to the schedule.`
  },
  DEFAULTFILTERAUTOSCHEDULE: {
    LABEL: `Auto scheduling`,
    DESCRIPTION: `This filter will be used to determine the user's eligibility for each shift.`
  },
  SHIFTS: `Shifts:`,
  OTHERS: `Others:`,
  PROCEDURES: `Procedures`,
  PROCEDURE_DESCRIPTION: `The procedure will be used in the order that they appear here.`,
  PROCEDURE_REQUIRED: `The procedure field is mandatory and must contain at least one.`,
  USER_FILTER: `Filter`,
  USER_SORT: `Sort`,
  LIST: {
    TITLE: `Contact list configurations`,
    SUMMARY: `Contact list configurations allow creating a single list with multiple procedures, such as a list with regular and overtime one after the other.`,
    DELETE_BUTTON: {
      TITLE: `Delete the contact list configuration`,
      SUMMARY: `Are you sure you want to delete this configuration?`,
      PRIMARY_ACTION: `Delete`
    }
  },
  PROCEDURE: {
    TITLE: `Procedures`,
    SUMMARY: `Procedures are a named pair of a sort and filter. They allow filtering and sorting a list of employees in one action.`,
    DELETE_BUTTON: {
      TITLE: `Delete the procedure`,
      SUMMARY: `Are you sure you want to delete this procedure?`,
      PRIMARY_ACTION: `Delete`
    },
    DEPENDENCIES: `<0>Warning: </0>You cannot delete this procedure because some contact list configurations are using them:<1></1> 
    Please update the contact list configurations first before deleting this procedure.`
  },
  SORT: {
    TITLE: `Sort orders`,
    SUMMARY: `A sort order is used to sort employees based on specific traits or experience they might have.`,
    DELETE_BUTTON: {
      TITLE: `Delete the sort`,
      SUMMARY: `Are you sure you want to delete this sort?`,
      PRIMARY_ACTION: `Delete`
    },
    DEPENDENCIES: `<0>Warning: </0>You cannot delete this sort because some procedures are using them:<1></1> 
    Please update the procedures first before deleting this sort.`
  },
  FILTER: {
    TITLE: `Filters`,
    SUMMARY: `A filter is a collection of toggles and options that configure which users should be filtered from a list of users on a specific date or shift.`,
    DELETE_BUTTON: {
      TITLE: `Delete the filter`,
      SUMMARY: `Are you sure you want to delete this filter?`,
      PRIMARY_ACTION: `Delete`
    },
    DEPENDENCIES: `<0>Warning: </0>You cannot delete this filter because some procedures are using them:<1></1> 
    Please update the procedures first before deleting this filter.`
  },
  CREATE_CONFIG: `Create a config`,
  CREATE_FILTER: `Create a filter`,
  CREATE_SORT: `Create a sort`,
  CREATE_PROCEDURE: `Create a procedure`,
  CONCURRENT_CALLS_RATIO: `Ratio of maximum concurrent calls`,
  DELETE_BUTTON: {
    TITLE: `Are you sure you want to delete this?`,
    SUMMARY: ``,
    PRIMARY_ACTION: `Delete`
  },
  NAME_REQUIRED: `The name is mandatory.`,
  DESCRIPTION_REQUIRED: `The description is mandatory.`,
  procedure: {
    CREATE: {
      TITLE: `Create a procedure`,
      SUMMARY: `Procedures are a named pair of a sort and filter. They allow filtering and sorting a list of employees in one action.`
    },
    EDIT: {
      TITLE: `Edit a procedure`,
      SUMMARY: `Procedures are a named pair of a sort and filter. They allow filtering and sorting a list of employees in one action.`
    },
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter the wanted name`,
      DESCRIPTION: `The name must describe briefly the sorted list of eligible users. The name will be displayed in the contact list interface.`
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Enter the wanted description`,
      DESCRIPTION: ``
    },
    USERFILTER: {
      LABEL: `Filter`,
      DESCRIPTION: `Filter to use to determine the eligible users.`
    },
    USERSORT: {
      LABEL: `Sort`,
      DESCRIPTION: `Order with which to sort the eligible users.`
    },
    INCLUDEINSCHEDULE: {
      LABEL: `Include in schedule`,
      DESCRIPTION: `If checked, the procedure will be available as an option to sort and filter the users in the schedule.`
    }
  },
  configuration: {
    CREATE: {
      TITLE: `Create a configuration`,
      SUMMARY: `Contact list configurations allow creating a single list with multiple procedures, such as a list with regular and overtime one after the other.`
    },
    EDIT: {
      TITLE: `Edit a configuration`,
      SUMMARY: `Contact list configurations allow creating a single list with multiple procedures, such as a list with regular and overtime one after the other.`
    },
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter the wanted name`,
      DESCRIPTION: ``
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Enter the wanted description`,
      DESCRIPTION: ``
    },
    CONCURRENTCALLSRATIO: {
      LABEL: `Ratio of maximum concurrent calls`,
      PLACEHOLDER: `Enter the ratio`,
      DESCRIPTION: `This is a ratio of the maximum number of users that can be contacted to the number of shifts left to replace. It will be used to calculate how many users can be contacted concurrently. (Must be greater than 0) If a default ratio is already set, it will be overwritten only for this list configuration.`
    },
    PROCEDURE: {
      LABEL: `Procedure`,
      DESCRIPTION: ``
    },
    REMOVEIFINPREVIOUSLIST: {
      LABEL: `Remove if in previous list`,
      DESCRIPTION: `Prevents a user from being eligible for a shift in this list if they are eligible in a previous list.`
    },
    APPROVEDBYDEFAULT: {
      LABEL: `Approve by default`,
      DESCRIPTION: `This list will be approved by default when creating the contact list. The first list is always approved by default.`
    }
  },
  sorts: {
    CREATE: {
      TITLE: `Create a sort`,
      SUMMARY: `A sort order is used to sort employees based on specific traits or experience they might have.`
    },
    EDIT: {
      TITLE: `Edit a sort`,
      SUMMARY: `A sort order is used to sort employees based on specific traits or experience they might have.`
    },
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter the wanted name`,
      DESCRIPTION: ``
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Enter the wanted description`,
      DESCRIPTION: ``
    }
  },
  filters: {
    CREATE: {
      TITLE: `Create a filter`,
      SUMMARY: `A filter is a collection of toggles and options that configure which users should be filtered from a list of users on a specific date or shift.`
    },
    EDIT: {
      TITLE: `Edit a filter`,
      SUMMARY: `A filter is a collection of toggles and options that configure which users should be filtered from a list of users on a specific date or shift.`
    },
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter the wanted name`,
      DESCRIPTION: ``
    },
    DESCRIPTION: {
      LABEL: `Description`,
      PLACEHOLDER: `Enter the wanted description`,
      DESCRIPTION: ``
    },

    HOUR_RANGES: `Hour limits by period`,
    HOUR_RANGES_DESCRIPTION: `You can have multiple periods overlapping. For example: one of 7 days and one of 14 days with different rules for each one.`,
    FLAG_OPTIONS: 'Flag options',
    HOUR_LIMITS: `Hours limit`,
    OPTIONS: {
      DISTANCEBETWEENSHIFTS: {
        LABEL: `Distance between 2 shifts`,
        PLACEHOLDER: `Enter the amount of minutes between 2 shifts`,
        DESCRIPTION: `The amount entered will be used to calculate the eligibility of a user for a shift based on adjacent shift.`
      },
      ALLOWEDHIRINGDATA: {
        LABEL: `Allowed hiring data`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Only the employee having the selected hiring data will be marked has eligible. Leave empty to allow all hiring data.`
      },
      MAXCONSECUTIVETIME: {
        LABEL: `Max consecutive time`,
        PLACEHOLDER: `Enter the maximal amount in minutes`,
        DESCRIPTION: `Used to determine the eligibility of a user to a shift if they already work on that day.`
      }
    },
    PERIODDURATION: {
      LABEL: `Period duration`,
      PLACEHOLDER: `Enter the length of the period in days`,
      DESCRIPTION: ``
    },
    MAXHOURS: {
      LABEL: `Max amount of scheduled hours in the period`,
      PLACEHOLDER: `Enter the amount in hours`,
      DESCRIPTION: ``
    },
    BASEDATE: {
      LABEL: `Base date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Beginning reference date for the period`
    }
  },
  ADD_SORT: `Add`,
  REMOVE_SORT: `Remove`,
  USED_SORTS: `Sorts`,
  SORTS: `Sorts`,
  SORTS_DESCRIPTION: `The sorting functions are run in order, so the last one will have the most impact.`,
  SORTS_REQUIRED: `You need to add at least one sort.`,
  FIELD_REQUIRED: `This field is mandatory.`,
  sortFilterKey: {
    EVENTS: 'Event flags',
    REQUESTS: 'Request flags',
    HIRING_INFORMATIONS: 'Hiring data flags',
    PROJECTS: 'Project flags',
    OTHERS: 'Other flags',
    FLAG_OPTIONS: 'Flag options',
    FILTER_NAME: 'Filter name',
    FILTER_DESC: 'Filter description',
    CONFIGURE: 'Configure',
    DISTANCE_BETWEEN_SHIFTS: 'Minimum distance between shifts',
    DISTANCE_BETWEEN_SHIFTS_PLACEHOLDER: 'Distance in minutes',
    ALLOWED_CONTRACT_TYPES: 'Allowed hiring data',
    ALLOWED_CONTRACT_TYPES_PLACEHOLDER: 'Select contracts/permits/employee types',
    HOUR_LIMITS: 'Hour limits by period',
    PERIOD_DURATION: 'Period duration',
    PERIOD_DURATION_PLACEHOLDER: 'Calculation period (in days)',
    MAX_NUMBER_OF_HOURS: 'Max number of hours',
    MAX_NUMBER_OF_HOURS_PLACEHOLDER: 'Number of hours scheduled',
    PERIOD_START_DATE: 'Start date',
    PERIOD_START_DATE_PLACEHOLDER: 'Start date of a period',
    RANGE: 'Hour range',
    ADD_HOUR_RANGE: 'Add hour range',
    ADD_FILTER: 'Add a new type of filter',
    DEFAULT_CONFIGURATION: 'Default configuration',
    MAIN_SCHEDULE: 'Main filter for scheduling',
    EMPLOYEE_LIST_WARNINGS: 'Main filter for employee list warnings',
    MAIN_SCHEDULE_DESC: 'The filter to use when sorting list of candidates for shifts in the schedule.',
    EMPLOYEE_LIST_WARNINGS_DESC: 'The filter to use when flagging employees in the manage pane.',
    MAIN_SCHEDULE_SORT: 'Main sort for scheduler',
    MAIN_SCHEDULE_SORT_DESC: 'Sort to use for suggesting candidates in the schedule.',
    EMPLOYEE_NUMBER: 'Employee number',
    EMPLOYEE_NUMBER_DESC: 'Sorts using employee numbers',
    PRIORITY_NUMBER: 'Priority number',
    PRIORITY_NUMBER_DESC: 'Sorts using employee priority number',
    HIRING_DATE: 'Hiring date',
    HIRING_DATE_DESC: 'Sorts using hiring date',
    SENIORITY_DATE: 'Seniority date',
    SENIORITY_DATE_DESC: 'Sorts using seniority date',
    AVAILABILITY: 'Availability',
    AVAILABILITY_DESC: 'Sorts using amount of availability',
    ATTENDANCE: 'Attendance',
    ATTENDANCE_DESC: 'Sorts based on historical attendance',
    ATTRIBUTE_LEVELS: 'Attribute levels',
    ATTRIBUTE_LEVELS_DESC: 'Sorts based on attribute level',
    CONTRACT_TYPE: 'Contract types',
    CONTRACT_TYPE_DESC: 'Sorts using contract type with defined order',
    PERMIT_TYPES: 'Permit types',
    PERMIT_TYPES_DESC: 'Sorts using permit type with defined order',
    EMPLOYEE_TYPES: 'Employee types',
    EMPLOYEE_TYPES_DESC: 'Sorts using employee type with defined order',
    CONFIG_NAME: 'Configuration name',
    CONFIG_DESC: 'Configuration description',
    PROCEDURE_NAME: 'Procedure name',
    PROCEDURE_DESC: 'Procedure description',
    PROCEDURES_DESC: 'Procedures are a named pair of a sort and filter. They allow filtering and sorting a list of employees in one action.',
    ADD_PROCEDURE: 'Add procedure',
    SHIFT_SWAP_AND_OFFER: 'Main filter for shift swap',
    SORT_NAME: 'Sort order name',
    SORT_DESC: 'Sort order description',
    ADD_SORT: 'Add a new sort order',
    NO_SORT: 'No sort',
    PROCEDURE_DELETE_CONFIRMATION: 'Are you sure you want to delete this procedure?',
    SORT_DELETE_CONFIRMATION: 'Are you sure you want to delete this sort?',
    FILTER_DELETE_CONFIRMATION: 'Are you sure you want to delete this filter?',
    CONTACT_CONFIG_DELETE_CONFIRMATION: 'Are you sure you want to delete this config?',
    SORT_SAVED: 'Sort saved',
    FILTER_SAVED: 'Filter saved',
    PROCEDURE_SAVED: 'Procedure saved',
    CONTACT_CONFIG_SAVED: 'Contact config saved',
    SORT_UPDATED: 'Sort updated',
    FILTER_UPDATED: 'Filter updated',
    PROCEDURE_UPDATED: 'Procedure updated',
    CONFIG_UPDATED: 'Contact config updated',
    SORT_DELETED: 'Sort deleted',
    FILTER_DELETED: 'Filter deleted',
    PROCEDURE_DELETED: 'Procedure deleted',
    CONTACT_CONFIG_DELETED: 'Contact config deleted',
    PROJECT_EXPERIENCE: 'Project experience',
    PROJECT_EXPERIENCE_DESC: 'Sorts using experience on a project',
    CONTACT_LIST_DEFAULT_CONFIG: 'Contact list default configuration',
    CONTACT_LIST_DEFAULT_CONFIG_DESC: 'Default configuration to use for contact lists.',
    QUICK_ADD_DEFAULT_FILTER: 'Quick add default filter',
    QUICK_ADD_DEFAULT_FILTER_DESC: 'Default filter to use for quick add in schedule template',
    NO_PROCEDURE: 'No procedure',
    NO_CONFIG: 'No configuration',
    NUMBER_OF_HOURS_RANGE: 'Number of hours in period',
    NUMBER_OF_HOURS_RANGE_DESC: 'Sorts based on number of hours planned in current period',
    ADD_CONTACT_LIST_CONFIG: 'Contact list configurations',
    CONTACT_LIST_CONFIG_DESC:
      'Contact list configurations allow creating a single list with multiple procedures, such as a list with regular and overtime one after the other.',
    REMOVE_USERS_FROM_PREVIOUS_LIST: 'Remove if in previous list',
    REMOVE_USERS_FROM_PREVIOUS_LIST_DESC: 'Prevents a user from being eligible for a shift in this list if they are eligible in a previous list.',
    IS_WORKING_SORT: 'Is working',
    IS_WORKING_SORT_DESC: 'Sorts based on how many days a user is working in the selected period.',
    DEPARTMENT: 'Departments',
    DEPARTMENT_DESC: "Sorts based on a user's and the structure's departments",
    MAX_CONSECUTIVE_TIME: 'Max consecutive time worked',
    MAX_CONSECUTIVE_TIME_PLACEHOLDER: 'Enter max in minutes',
    CROWS_FLIGHT_DISTANCE_SORT: 'Distance',
    CROWS_FLIGHT_DISTANCE_SORT_DESC: "Sorts based on distance between the user's address and the location's address",
    BACK_TO_CONTACT_LIST_CONFIG_MGMT: 'Back to contact list configurations list',
    BACK_TO_PROCEDURES_MGMT: 'Back to procedures list',
    BACK_TO_SORTS_MGMT: 'Back to sort orders list',
    BACK_TO_FILTERS_MGMT: 'Back to filters list',
    NUMBER_OF_TIMES_CONTACTED_SORT: 'Number of times contacted',
    NUMBER_OF_TIMES_CONTACTED_SORT_DESC: 'Sorts based on how many times the user was contacted',
    LAST_ACCEPTED_SORT: 'Last accepted',
    LAST_ACCEPTED_SORT_DESC: 'Sorts based on the last user, in order of priority, to accept a shift',
    LAST_ACCEPTED_BY_POSITION_SORT: 'Last accepted by position',
    LAST_ACCEPTED_BY_POSITION_SORT_DESC: 'Sorts based on the last user, in order of priority, to accept a shift in a list for the same position',
    MAIN_AUTO_SCHEDULE_FILTER: 'Main filter for auto scheduling',
    MAIN_AUTO_SCHEDULE_FILTER_DESC: "This filter will be used to determine the user's eligibility for each shift.",
    NUMBER_OF_HOURS_OFFERED_SORT: 'Number of hours offered',
    NUMBER_OF_HOURS_OFFERED_SORT_DESC: 'Sorts based on how many hours a user has accepted or has been offered in a contact list',
    CLIENT_SENIORITY_SORT: 'Seniority by client',
    CLIENT_SENIORITY_SORT_DESC: 'Uses the highest seniority found for a specific shift based on the client it is assigned to.',
    POSITION_SENIORITY_SORT: 'Seniority by position',
    POSITION_SENIORITY_SORT_DESC: 'Uses the highest seniority found for a specific shift based on the position it is assigned to.',
    OVERWRITEWHENACCEPTED: {
      LABEL: 'Overwrite number of hours offered',
      DESCRIPTION: 'If checked, when a user accepts a shift, the number of hours offered will be set to the duration of the accepted shift'
    },
    SORT_CONFIG_DESC:
      'A sort order is used to sort employees based on specific traits or experience they might have. The sorting functions are run in order, so the last one will have the most impact.',
    FILTER_CONFIG_DESC:
      'A filter is a collection of toggles and options that configure which users should be filtered from a list of users on a specific date or shift.',
    INCLUDEASSOCIATEDPROJ: {
      LABEL: `Include associated project's experience`,
      DESCRIPTION: ``
    },
    CONCURRENT_CALLS_RATIO: `Ratio of maximum concurrent calls`,
    CONCURRENT_CALLS_RATIO_DESC: `This is a ratio of the maximum number of users that can be contacted to the number of shifts left to replace. It will be used to calculate how many users can be contacted concurrently. (Must be greater than 0)`,
    CONCURRENT_CALLS_RATIO_NOTE: `If a default ratio is already set, it will be overwritten only for this list configuration.`,
    PREFERRED_ATTRIBUTES_SORT: `Preferred Attributes`,
    PREFERRED_ATTRIBUTES_SORT_DESC: `Sorts based on users that have preferred attributes`,
    OCCUPATIONS_SORT: `Occupations`,
    OCCUPATIONS_SORT_DESC: `Sorts based on user occupations, putting primary occupations, then secondary, then other users.`,
    MISSING_NAME: `Please enter a name`
  },
  sortOrder: {
    OPTIONS: { asc: 'Ascending', desc: 'Descending' }
  },
  flags: {
    EVENT_STARTS_DURING: 'Event starts during range',
    EVENT_STARTS_DURING_DESC: 'Flags users who are assigned to an event that begins during the selected range.',
    EVENT_ENDS_DURING: 'Event ends during range',
    EVENT_ENDS_DURING_DESC: 'Flags users assigned to an event that ends during the selected range.',
    EVENT_OVERLAPPING: 'Event overlaps range',
    EVENT_OVERLAPPING_DESC: 'Flags users assigned to an event that overlaps with the selected range.',
    EVENT_DISTANCE: 'Distance from range',
    EVENT_DISTANCE_DESC: 'Flags users if an event is not at least the minimum distance set in flag options.',
    UNAVAILABLE_OVERLAP: 'Unavailable during range',
    UNAVAILABLE_OVERLAP_DESC: 'Flags users who are unavailable during the range.',
    NO_CURRENT_AVAILABILITY: 'No current availabilities',
    NO_CURRENT_AVAILABILITY_DESC: 'Flags users who have not entered their availabilities.',
    PENDING_AVAILABILITY: 'Pending availability',
    PENDING_AVAILABILITY_DESC: 'Flags users who have pending availabilities during the selected range.',
    UNAVAILABLE_ALL_DAY: 'Unavailable',
    UNAVAILABLE_ALL_DAY_DESC: 'Flags users who are unavailable the whole day, but ignores unavailability during the day.',
    TIME_OFF_OVERLAPPING: 'Time off overlapping',
    TIME_OFF_OVERLAPPING_DESC: 'Flags users with an overlapping time off.',
    TIME_OFF_DURING_WEEK: 'Time off during week',
    TIME_OFF_DURING_WEEK_DESC: 'Applies filter to user if they have time off during the week.',
    LEAVE_OVERLAPPING: 'Absence overlapping',
    LEAVE_OVERLAPPING_DESC: 'Applies filter to user if they have an overlapping absence.',
    EMPLOYEE_TYPE: 'Employee type',
    EMPLOYEE_TYPE_DESC: 'Flags users of the correct employee type.',
    EMPLOYEE_STATUS: 'Employee status',
    EMPLOYEE_STATUS_DESC: 'Flags inactive users.',
    HAS_RESTRICTIONS: 'Has restrictions',
    HAS_RESTRICTIONS_DESC: 'Flags users with one or more restrictions.',
    MISSING_SKILLS: 'Missing skills',
    MISSING_SKILLS_DESC: 'Flags users without the correct skills and skill levels.',
    MISSING_REQUIREMENTS: 'Missing requirements',
    MISSING_REQUIREMENTS_DESC: 'Flags users without the correct requirements and requirement levels.',
    EXPIRED_CONTRACT: 'Expired contract',
    EXPIRED_CONTRACT_DESC: 'Flags users with expired contracts.',
    EXPIRED_PERMIT: 'Expired permit',
    EXPIRED_PERMIT_DESC: 'Flags users with expired permits.',
    EXPIRED_EMPLOYEE_TYPE: 'Expired employee type',
    EXPIRED_EMPLOYEE_TYPE_DESC: 'Flags users with an expired employee type.',
    NO_CONTRACT: 'No contract',
    NO_CONTRACT_DESC: 'Flags users without a contract.',
    NO_PERMIT: 'No permit',
    NO_PERMIT_DESC: 'Flags users without a permit.',
    NO_EMPLOYEE_TYPE: 'No employee type',
    NO_EMPLOYEE_TYPE_DESC: 'Flags users without an employee type.',
    MAX_NUMBER_OF_HOURS: 'Max number of hours',
    MAX_NUMBER_OF_HOURS_DESC: 'Flags users with more than the number of hours allowed by their employee type/permit/contract.',
    MAX_NUMBER_OF_HOURS_PER_DAY: 'Max number of assigned hours per 24 hour period',
    MAX_NUMBER_OF_HOURS_PER_DAY_DESC:
      'If the user has more than the number of hours allowed per day, they will be filtered out. (Takes into account the start time of the shift)',
    MAX_NUMBER_OF_HOURS_PER_DAY_START_TIME: 'Workday start time to consider when filtering for the max number of hours',
    MAX_NUMBER_OF_HOURS_PER_DAY_START_TIME_DESC: ' ',
    NUMBER_OF_HOURS_MAX_PER_DAY: 'Max time worked per day (in minutes)',
    NUMBER_OF_HOURS_MAX_PER_DAY_DESC: 'Min: {{ min }}, Max: {{ max }}',
    MAX_CONSECUTIVE_DAYS: `Max number of consecutive days`,
    MAX_CONSECUTIVE_DAYS_DESC: `Filters out users that work more than a certain number of days in a row.`,
    NUMBER_OF_MAX_CONSECUTIVE_DAYS: `Maximum number of days`,
    NUMBER_OF_MAX_CONSECUTIVE_DAYS_DESC: `Min: {{ min }}, Max: {{ max }}`,
    RIGHT_DEPARTMENT: 'Right department',
    RIGHT_DEPARTMENT_DESC: 'Flags users in a different department.',
    RIGHT_TEAM: 'Right team',
    RIGHT_TEAM_DESC: 'Flags users that are not assigned to this team.',
    RIGHT_PROJECT: 'Right project',
    RIGHT_PROJECT_DESC: 'Flags users that are not assigned to this project.',
    INACTIF_USER: 'Inactive user',
    INACTIF_USER_DESC: 'Flags users marked as inactive.',
    ARCHIVED_USER: 'Archived user',
    ARCHIVED_USER_DESC: 'Flags archived users.',
    CHECK_START_AND_END: 'Outside employment range',
    CHECK_START_AND_END_DESC: 'Flags users if the shift is before their start date or after their termination date.',
    TERMINATED_USER: 'Terminated user',
    TERMINATED_USER_DESC: 'Flags terminated users.',
    PROJECT_LOCK: 'Locked to project',
    PROJECT_LOCK_DESC: 'Flags users locked to a project.',
    IN_REST_TIME: 'In rest time',
    IN_REST_TIME_DESC: 'Flags users with a rest time that is still in progress during the shift.',
    MISSING_REGION: 'Missing region',
    MISSING_REGION_DESC: "Flags users whose region does not match the shift's region.",
    ADJACENT_SHIFTS: 'Adjacent shifts',
    ADJACENT_SHIFTS_DESC:
      'Flags users without shifts adjacent (starting after and/or ending before) to the selected shift. To enable this feature, at least one of the following boxes must be selected.',
    ADJACENT_BEFORE: 'Shift starting before',
    ADJACENT_BEFORE_DESC: 'Flags users without a shift starting before the selected shift.',
    ADJACENT_AFTER: 'Shift starting after',
    ADJACENT_AFTER_DESC: 'Flags users without a shift starting after the selected shift.',
    FILTER_BY_POSITION: 'Position',
    FILTER_BY_POSITION_DESC: 'Flags users if they do not have the right position.',
    MAX_CONSECUTIVE_TIME: 'Max consecutive time worked',
    MAX_CONSECUTIVE_TIME_DESC: `Flags users working more than one shift back-to-back if the total time exceeds the number of minutes set below. Overlapping shifts are not counted.`,
    OVERTIME_MAX_HOURS_PER_RANGE: `Overtime`,
    OVERTIME_MAX_HOURS_PER_RANGE_DESC: `Overtime shifts will not be included in the calculation of the maximum number of hours worked in a period.`,
    OVERTIME_MAX_HOURS_PER_DAY: `Overtime`,
    OVERTIME_MAX_HOURS_PER_DAY_DESC: `Overtime shifts will not be included in the calculation of the maximum number of hours worked in a day.`,
    OVERTIME_EVENT_DISTANCE: `Overtime`,
    OVERTIME_EVENT_DISTANCE_DESC: `Overtime shifts will not be included in the calculation of the distance between shifts.`,
    OVERTIME_MAX_CONSECUTIVE_HOURS: `Overtime`,
    OVERTIME_MAX_CONSECUTIVE_HOURS_DESC: `Overtime shifts will not be included in the calculation of the maximum number of hours worked in consecutively.`,
    PROJECT_LOCK_BY_DAY: 'Locked to project by day',
    PROJECT_LOCK_BY_DAY_DESC: "A user will only trigger 'Locked to project' warnings if one or more of their projects are scheduled on the date in question.",
    PROJECT_PREFER: 'Preferred on project',
    PROJECT_PREFER_DESC: "Flags users' preferred projects when attempting to assign them to a different project.",
    PROJECT_PREFER_BY_DAY: 'Preferred on project by day',
    PROJECT_PREFER_BY_DAY_DESC:
      "A user will only trigger 'Preferred on project' warnings if one or more of their preferred projects are scheduled on the date in question.",
    PROJECT_BLOCK: 'Blocked on project',
    PROJECT_BLOCK_DESC: 'A warning will be displayed when attempting to schedule a user to a project on which they are blocked.',
    RESTRICT_WORKABLE_HOURS: 'Restrict the workable hours',
    RESTRICT_WORKABLE_HOURS_DESC: 'The user will be restricted to the range of hours defined from the employee type/contact/permit.'
  }
}
